module.exports = __webpack_public_path__ + "assets_1789978653902/img/logo_v1.dc05f9dd.png";